import { useEffect } from 'react'

import ReactPixel from 'react-facebook-pixel'

import { useProject } from '../../api/project'
import { useShowingSignupResult } from '../../context/showingSignupResult'
import { useSignup } from '../../context/signup'
import { useProjectId } from '../../hooks/useProjectId'

/**
The `debug` option toggles console logging of triggered events, see:
  https://github.com/zsajjad/react-facebook-pixel#how-to-use
The `autoConfig` option toggles triggering of event on all button clicks, see:
  https://developers.facebook.com/docs/facebook-pixel/advanced#automatic-configuration
**/
const options = { debug: false, autoConfig: false }

const FacebookPixel = ({ reactPixel }) => {
  const { data: project } = useProject(useProjectId())
  const pixelId = project?.facebookPixelId

  const { user } = useSignup() || {}
  const acceptTracking = user?.acceptTracking
  const trackInterestSignup = user?.signupType == 'INTEREST'
  const trackSalesSignup = user?.signupType == 'SALES_START'

  const { result: showingSignup } = useShowingSignupResult()
  const acceptTrackingShowingSignup = showingSignup?.acceptTracking
  const trackShowingSignup = showingSignup?.signupType == 'SHOWING'

  useEffect(() => {
    // Tracking of interest signups
    if (!pixelId) return
    if (!acceptTracking) return
    if (!trackInterestSignup) return
    reactPixel?.init(pixelId, {}, options)
    reactPixel?.pageView()
    reactPixel?.track('Lead')
  }, [pixelId, reactPixel, acceptTracking, trackInterestSignup])

  useEffect(() => {
    // Tracking of sales start signups
    if (!pixelId) return
    if (!acceptTracking) return
    if (!trackSalesSignup) return
    reactPixel?.init(pixelId, {}, options)
    reactPixel?.pageView()
    reactPixel?.track('Lead')
  }, [pixelId, reactPixel, acceptTracking, trackSalesSignup])

  useEffect(() => {
    // Tracking of showing signups
    if (!pixelId) return
    if (!acceptTrackingShowingSignup) return
    if (!trackShowingSignup) return
    reactPixel?.init(pixelId, {}, options)
    reactPixel?.pageView()
    reactPixel?.track('Lead')
  }, [pixelId, reactPixel, acceptTrackingShowingSignup, trackShowingSignup])

  return false
}

export const Wrapper = (props) => (
  <FacebookPixel reactPixel={ReactPixel} {...props} />
)
